import { type Member } from '@/features/iam/members/Member'
import { type Workspace } from '@/features/iam/workspaces/Workspace'
import type { CallCenterContact } from '@/features/freshbooks/CallCenterContact'

export interface CallCenterWorkspaceMemberMatch {
  member: Member
  workspace: Workspace
}

export interface CallCenterSearchResult {
  key: string
  hubspotContact: CallCenterContact | null
  workspaceMembers: CallCenterWorkspaceMemberMatch[]
}

function normalizeEmail(email?: string | null): string {
  return (email || '').trim().toLowerCase()
}

export function resultKeyFromHubSpotContact(contact: CallCenterContact) {
  const emailKey = normalizeEmail(contact.email)
  return emailKey ? `email:${emailKey}` : `contact:${contact.id}`
}

export function resultKeyFromMember(member: Member) {
  const emailKey = normalizeEmail(member.email)
  return emailKey ? `email:${emailKey}` : `member:${member.user.publicId}`
}

export function dedupeCallCenterMatches<
  T extends CallCenterWorkspaceMemberMatch,
>(matches: T[]): T[] {
  const seen = new Set<string>()
  return matches.filter((match) => {
    const key = `${match.workspace.id}:${match.member.user.publicId}`
    if (seen.has(key)) {
      return false
    }
    seen.add(key)
    return true
  })
}

export function sortMatchesByLatestLogin(
  matches: CallCenterWorkspaceMemberMatch[],
): CallCenterWorkspaceMemberMatch[] {
  return matches.slice().sort((a, b) => {
    const aTime = a.member.lastLogin?.getTime() ?? 0
    const bTime = b.member.lastLogin?.getTime() ?? 0
    return bTime - aTime
  })
}
